<div class="relative w-full pb-[56.25%]" [ngClass]="{ 'cursor-pointer': openInDialog && videoURL }">
  <app-responsive-video class="absolute top-0 left-0 w-full h-full z-30" [videoURL]="videoURL"></app-responsive-video>
  @if (openInDialog && videoURL) {
    <div
      class="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-transparent z-30"
      (click)="handleClick()"></div>
  }

  @if (redirectToURL && videoURL) {
    <a
      class="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-transparent z-30"
      href="{{ videoURL }}"
      target="_blank">
    </a>
  }
</div>
